import React, { createContext, useContext } from 'react';
import useNotificationCount from '../hooks/useNotificationCount';

const NotificationContext = createContext();

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const notificationCount = useNotificationCount();

  return (
    <NotificationContext.Provider value={notificationCount}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;